import {NUMBER} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: NUMBER,
  attribute: 'vehicle',
  label: {
    default: 'Vehicle',
    short: 'Vehicle',
  },
});
